import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { ExtraWideBody } from '@ui';
import TableAnalysisTool from '@containers/TableAnalysis/TableAnalysisTool';
import { GRID_MODES } from '@containers/gridMode';
import { AI_TOOLS } from '@constants';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.PPM_TABLE_ANALYSIS;

function PPMTableAnalysis() {
  const [docMode] = React.useState(GRID_MODES.ppm);

  return (
    <PageWrapper>
      <Header />
      <ExtraWideBody withFooter>
        <TableAnalysisTool docMode={docMode} tool={tool} />
      </ExtraWideBody>
    </PageWrapper>
  );
}

export default PPMTableAnalysis;
